<template>
    <div class="container">
        <div class="nTop">
            <div class="wrapper clearfix">
                <a href="" class="logo"><img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司"><h1>佰吉宏安国际能源有限公司</h1></a>
                <a href="" class="nt-link1">返回首页</a>
            </div>
        </div>
        <img src="../../assets/images/register-img_01.png" alt="">
        <div class="main">
            <div class="title">注册条款</div>
            <div class="content_border">
                <div class="content">
                    同意并接受以下服务条款，即用户与我公司已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。

（一）
您确认，在您注册成为本站用户以及接受本服务之前，你已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。

（二）
您同意，本公司有权随时对本协议内容进行单方面的变更和公司网站公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，请立即停止使用本服务。

（三） 
您声明，在您同意接受本协议并注册成为本站用户时，您是具有法律规定的完全民事权力能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织；本协议内容不受您所属国家或地区的排斥。

（四） 
您承诺，在您注册成为本站会员时应与本站一起维护本站的名誉和利益，不得在论坛、播客等通讯工具上发布诽谤、诬陷等对本站不利的信息和图片，您有义务举报对本站不利的相关言论和行为。如发现注册会员有该行为，
本站有权注销会员账户，并保留追究其法律责任的权利。不具备前述条件的，您应立即终止注册或停止使用本服务。
                </div>
            </div>
        </div>
       <div class="footer">
       	<div class="wrapper">
       		<div class="f-nav">
       			<a href=""><router-link  to="/home">首页</router-link></a>
       			<a href=""><router-link  to="/about">关于我们</router-link></a>
       			<a href=""><router-link  to="/honor">资质荣誉</router-link></a>
       			<a href=""><router-link  to="/product">主营产品</router-link></a> 
       			<a href=""><router-link  to="/bidding">招标信息</router-link></a>
       			<a href=""><router-link  to="/partner">合作伙伴</router-link></a>
       			<a href=""><router-link  to="/news">新闻资讯</router-link></a>
       			<a href=""><router-link  to="/contact">联系我们</router-link></a>
       		</div>
       		<div class="f-box flexbox">
       			<img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot">
       			<div class="f-center flexbox33 flexwarp" style="text-align: left;">
       				<div class="f-item clearfix"><img src="../../assets/images/ico05.png"><p>联系电话：{{footerMassage.mobile}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico06.png"><p>邮政编码：{{footerMassage.postal}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico07.png"><p>访问量：{{footerMassage.pageviews}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico08.png"><p>电子邮箱：{{footerMassage.email}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico09.png"><p>公司地址：{{footerMassage.address}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico10.png"><p>交易量：{{footerMassage.trading_volume}}</p></div>
       			</div>
       			<div class="qrcode">
       				<img :src="footerMassage.image_id5_url" alt="">
       				<p>扫一扫了解更多</p>
       			</div>
       		</div>
       		<div class="copyright">
       			Copyright  2021 ·版权所有 佰吉宏安国际能源有限公司　　<a  href="https://beian.miit.gov.cn" target="_blank">{{footerMassage.site_icp}}&nbsp;{{footerMassage.site_wabah}}</a><br>
       			建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
       		</div>
       	</div>
       </div>
    </div>
</template>

<script>
    export default {
        name: 'register',
        data() {
            return {
                type: 1, // 1企业 2个人
                checked: false,
				footerMassage:''
            }
        },
		mounted() {
			this.site_info()
		},
        methods: {
			//底部导航信息
			async site_info(idnex) {
			    let { status, message, data } = await this.$ajax('site_info', {
			    });
			    if (status == this.SUCCESS_CODE) {
			        
			      this.footerMassage = data
			    } else {
			        this.$message.error(message);
			    }
			},
        }
    }
</script>

<style scoped>
    .container {
        background: #fff;
    }
    .main {
        display: flex;
        align-items: center;
        padding-top: 70px;
        flex-direction: column;
        padding-bottom: 100px;
    }
    .title {
        background: #af2f24;
        font-size: 17px;
        padding: 6px 0;
        color: #fff;
        font-weight: bold;
        width: 900px;
    }
    .content_border {
        background: #f6f6f6;
        width: 900px;
        padding: 10px;
    }
    .content {
        background: #fff;
        border: 1px solid #cccccc;
        height: 520px;
        overflow-y: auto;
        padding: 15px;
    }


    .tab {
        padding-top: 23px;
        display: flex;
        justify-content: center;
    }
    .tab .tab__item {
        width: 140px;
        line-height: 47px;
        background: #e5e5e5;
        font-size: 18px;
        font-weight: bold;
        color: #535353;
    }
    .tab .tab__item:first-child {
        margin-right: 15px;
    }
    .tab .tab__item.active {
        background: #af2f24;
        color: #ffffff;
    }
    
    .input-box {
        display: flex;
        height: 75px;
    }
    .upload-box {
        display: flex;
        height: 93px;
    }
    .upload-box div {
        text-align: left;
    }
    .input-box >span, .upload-box >span {
        display: inline-block;
        line-height: 42px;
        width: 80px;
        text-align: left;
    }
    .input-box .input {
        border: 1px solid #dfdfdf;
        border-radius: 5px;
        width: 340px;
        padding: 1px 16px;
        box-shadow: 0 2px 5px #eaeaea;
    }
    .tip {
        color: #ff1400;
        padding-top: 3px;
        text-align: left;
        padding-left: 3px;
    }
    .tel {
        display: flex;
        align-items: center;
    }
    .tel .input {
        width: 213px;
        margin-right: 15px;
    }
    .el-button--primary {
        color: #FFF;
        background-color: #106a95;
        border-color: #106a95;
        line-height: 18px;
    }
    .agreement {
        padding-top: 20px;
    }
    .agreement span {
        color: #0066cc;
    }
    .submit_btn {
        color: #fff;
        background: #af2f24;
        font-weight: bold;
        font-size: 20px;
        line-height: 46px;
        width: 250px;
        border-radius: 3px;
        margin: 20px 0 65px;
    }
    /* 顶部 */
    .nTop .nt-link1{display: block;width: 113px;height: 42px;border: 1px solid #dcdcdc;text-align: center;line-height: 40px;font-size: 16px;color: #838383;float: right;margin-top: 25px;transition: .5s;}
    .nTop .nt-link1:hover{background: #dcdcdc;}
</style>



// WEBPACK FOOTER //
// src/views/register/clause.vue